// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__g4_rh","box":"styles_box__97h3J","report":"styles_report__piA6G","banner":"styles_banner__lEngq","loadBtn":"styles_loadBtn__pjaC1"};